import { useEffect, useState } from 'react'

import useDevices from '@/hooks/cluster/useDevices'
import useUserInfo from '@/hooks/users/useUserInfo'

export const useEmailOverlay = () => {
  const [needsEmailAddition, setNeedsEmailAddition] = useState<boolean>(false)
  const [needsEmailConfirmation, setNeedsEmailConfirmation] =
    useState<boolean>(false)

  const { data, isFetching: isFetchingDevices } = useDevices()
  const {
    notificationEmail,
    hasSeenOnboarding,
    isFetching: isFetchingUserInfo
  } = useUserInfo()

  useEffect(() => {
    if (
      hasSeenOnboarding &&
      !isFetchingDevices &&
      !isFetchingUserInfo &&
      !needsEmailConfirmation
    ) {
      setNeedsEmailAddition(data?.totalDevices > 0 && !notificationEmail)
    }
  }, [
    data,
    notificationEmail,
    isFetchingDevices,
    hasSeenOnboarding,
    isFetchingUserInfo,
    needsEmailConfirmation
  ])

  const onAddEmailDialogOpen = () => {
    setNeedsEmailAddition(true)
  }

  const onAddEmailDialogClose = () => {
    setNeedsEmailAddition(false)
    setNeedsEmailConfirmation(true)
  }

  return {
    needsEmailAddition,
    onAddEmailDialogOpen,
    needsEmailConfirmation,
    onAddEmailDialogClose
  }
}
